import React from "react"
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import CCOContainer from "../../fundamentals/CCOContainer";
import CCOHeadline from "../../fundamentals/CCOHeadline";
import ArrowForwardFilled from '@mui/icons-material/ArrowForward';
import CCOLink from "../../fundamentals/CCOLink";
import CCOComponentWrapper from "../../fundamentals/CCOComponentWrapper";
import CCORichText from "../../fundamentals/CCORichText/CCORichText";
import {metaDataElementWithId} from "../../preview/previewMetaData";
import {usePreviewContext} from "../../../context/PreviewContext";
import {CmCollectionType, CmTeasableType} from "../../types";


import type { CAEGlobalSettings } from "../../../types/CAEGlobalSettings";

export interface Props {
    cmCollection: CmCollectionType
    CAEGlobalSettings: CAEGlobalSettings
}

function C013FAQ(props: Props) {
    const isPreview = usePreviewContext().isPreview;
    return (
        <CCOComponentWrapper background={"grey"}>
            <CCOHeadline metadataId={props.cmCollection.id} id={props.cmCollection.id}
                         type={"componenthead"}
                         propertyName='properties.teaserTitle'
                         subtextPropertyName='properties.teaserText'
                         headline={props.cmCollection.teaserTitle}
                         subtext={props.cmCollection.teaserText?.textAsTree}
                         background={"grey"}/>
            <CCOContainer width={"small"} background={"grey"}>

                {props.cmCollection.items?.map(i => i as CmTeasableType).map((i: any, index: number) => {
                        return (
                            <Grid
                                key={index}
                                size={{xs: 12, md: 12}}
                                {...metaDataElementWithId(isPreview, i.id)}
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'left',
                                    textAlign: 'left',
                                    marginBottom: 12
                                }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}>
                                    <CCOHeadline headline={i.teaserTitle}
                                                 metadataId={i.id}
                                                 propertyName='properties.teaserTitle'
                                                 type={'h4'}
                                                 strong={true}
                                                 margin={{l: i.picture ? 3 : undefined}}
                                    />
                                </Box>
                                {i.detailText ?
                                    <CCORichText textAsTree={i.detailText.textAsTree} metadataId={i.id}
                                                 propertyName={'properties.detailText'}/> : <></>}

                                {i.teaserTarget && i.linktext ? <CCOLink target={i.teaserTarget}>
                                    <Typography
                                        variant='linkLabel'
                                        sx={{
                                            color: "primary.main",
                                            fontWeight: 700,
                                            fontSize: '16px'
                                        }}>
                                        <ArrowForwardFilled
                                            sx={{width: '0.9em', height: '0.9em', mb: '-5px', mr: '8px'}}/>
                                        {`${i.linktext ?? ''}`}
                                    </Typography>
                                </CCOLink> : null}
                            </Grid>
                        );
                    }
                )
                }

            </CCOContainer></CCOComponentWrapper>
    );
}

export default C013FAQ